var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard1B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x36_",
    fill: "#85898B",
    d: "M359.9,372.5c3.2,0,9-0.2,12.1-0.1c3.7,0.1,3.9-0.3,4.1,3.2c0.1,2.3,0.2,2.9-0.8,4.2 c-2,2.5-5.3,4.7-6.7,5.8c-0.5,0.4-2.9,2.1-3.5,2.4c3.3,3.4,5.7,8.4,11.7,8.8c5,0.3,9.3,0,13.6-2.4c4.4-2.4,9.9-6,14.7-9.4 c2.6-1.8,8.1-5.8,9.9-7.1c2-1.4,6.4-3.6,7.3-2.8c-5.8,7.2-14.9,19.6-22,25.7c-7.4,6.4-19.3,15.8-29.1,16.3 c-11.6,0.6-21.7,1.2-32.1-4.4c-8.7-4.7-16.7-11.1-24.4-17.1c-4-3.1-7-6.1-11-9.8c-1.4-1.3-10.9-11.9-9.4-12.1c2.1-0.4,9,5.1,11,6.2 c8.2,4.7,14.6,9.4,23.5,13.2c4.7,2,11.6,4.4,16.8,2.7c2.4-0.8,4.2-2.2,5.9-3.9c0.8-0.8,3.1-3.1,3.4-4.2c0,0-0.4-0.3-2-1.7 c-2.6-2.3-7.2-4.6-8.6-7.4c-0.8-1.7-0.9-4.7,0.4-5.5c0.8-0.5,4.9-0.4,5.9-0.4c2.9-0.1,6.3-0.1,7.3-0.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard1B);
export default __webpack_public_path__ + "static/media/man_beard_1b.3272e1ed88d141082e1260a4f4ae7405.svg";
export { ForwardRef as ReactComponent };